<template>
    <div>

        <vue-headful title="Custom Forms :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-file-text"></i> Custom Forms</li>
                <li class="ml-3">
                    <router-link :to="`/custom-forms/entry/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create Entry</router-link>
                </li>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4" v-if="canManage">
            <b-nav-item :active="curTab === 'entries'" @click="curTab = 'entries'">
                Form Entries
            </b-nav-item>
            <b-nav-item :active="curTab === 'admin'" @click="curTab = 'admin'">
                Form Admin
            </b-nav-item>
            <b-nav-item :active="curTab === 'public'" @click="curTab = 'public'">
                Public Access
            </b-nav-item>
            <b-nav-item :active="curTab === 'alerts'" @click="curTab = 'alerts'">
                Alerts
            </b-nav-item>
        </ul>

        <div class="card" v-show="curTab == 'entries'">
            <div class="card-body">
                <saved-filter-title :filterKey="'customFormFilters'" />

                <covid-list :filterId="(filter_id ? parseInt(filter_id) : null)" />
            </div>
        </div>
        <template v-if="canManage">
            <div class="card" v-show="curTab == 'admin'">
                <div class="card-body">
                    <v-client-table ref="emailRulesTable" :columns="columns" :options="options" :data="forms">

                        <div slot="afterFilter" class="ml-2">
                            <router-link to="/custom-forms/forms/create" class="btn btn-success">
                                <i class="fa fa-plus-circle"></i> Create a Form
                            </router-link>
                        </div>

                        <template slot="id" slot-scope="props">
                            <router-link  :to="`/custom-forms/forms/edit/${props.row.id}`" title="Edit COVID Form" class="btn btn-sm btn-secondary">
                                <i class="fa fa-edit"></i> Edit
                            </router-link>
                        </template>

                        <router-link slot="covid_form_name" slot-scope="props" :to="`/custom-forms/forms/view/${props.row.id}`" title="View Form">
                            {{ props.row.covid_form_name }}
                        </router-link>

                        <template slot="require_jobsite" slot-scope="props">
                            <label v-if="props.row.require_jobsite == 1" class="badge badge-success">Yes</label>
                            <label v-else class="badge badge-secondary">No</label>
                        </template>

                        <template slot="require_employee_sig" slot-scope="props">
                            <label v-if="props.row.require_employee_sig == 1" class="badge badge-success">Yes</label>
                            <label v-else class="badge badge-secondary">No</label>
                        </template>

                        <template slot="enable_public_access" slot-scope="props">
                            <label v-if="props.row.enable_public_access == 1" class="badge badge-success">Yes</label>
                            <label v-else class="badge badge-secondary">No</label>
                        </template>

                        <template slot="enable_guest_access" slot-scope="props">
                            <label v-if="props.row.enable_guest_access == 1" class="badge badge-success">Yes</label>
                            <label v-else class="badge badge-secondary">No</label>
                        </template>
                    </v-client-table>
                </div>
            </div>

            <div class="card" v-show="curTab == 'alerts'">
                <div class="card-body">
                    <v-client-table ref="emailRulesTable" :columns="alertColumns" :options="alertOptions" :data="alertRules">

                        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                            <div class="clearfix d-md-none d-block"></div>

                            <div>
                                <router-link :to="`/email-alerts/create?asset_type=CustomFormEntry`" class="btn btn-success"><i class="fa fa-plus"></i> Create</router-link>
                            </div>
                        </div>

                        <template slot="id" slot-scope="props">
                            <router-link  :to="`/email-alerts/edit/${props.row.id}`" title="Edit Email Alert" class="btn btn-sm btn-light">
                                <i class="fa fa-edit"></i> Edit
                            </router-link>
                            <router-link :to="`/email-alerts/delete/${props.row.id}`" title="Delete Email Alert" class="btn btn-sm btn-light">
                                <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                            </router-link>
                        </template>

                        <router-link slot="alert_name" slot-scope="props" :to="`/email-alerts/edit/${props.row.id}`" title="Edit Email Alert">
                            {{ props.row.alert_name }}
                        </router-link>

                        <template slot="is_active" slot-scope="props">
                            <label v-if="props.row.is_active == 1" class="badge badge-success">Active</label>
                            <label v-if="props.row.is_active == 0" class="badge badge-warning">Inactive</label>
                        </template>

                        <template slot="child_row" slot-scope="props">
                            <div class="row" style="margin-right: -0.625rem; margin-left: -0.625rem;">
                                <div class="col-md-4 col-12 mb-md-0 mb-3">
                                    <span class="font-weight-bold">Description</span><br>
                                    <div v-html="props.row.description"></div>
                                </div>
                                <div class="col-md-4 col-12 mb-md-0 mb-3">
                                    <span class="font-weight-bold">Conditions</span><br>
                                    WHEN:
                                    <ol>
                                        <li v-for="(cond, key) in props.row.conditions">
                                            <template v-if="key > 0">AND:</template>
                                            {{ cond.field_label }} {{ cond.logic }} {{ cond.cond_label }}
                                        </li>
                                    </ol>
                                </div>
                                <div class="col-md-4 col-12 mb-md-0 mb-3">
                                    <span class="font-weight-bold">Recipients</span><br>
                                    Send Email To:
                                    <ol>
                                        <li v-for="(recip, key) in props.row.recipients">
                                            {{ recip.target_type }} -
                                            <template v-if="recip.target_type == 'Employee' || recip.target_type == 'User'">
                                                {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}
                                            </template>
                                            <template v-else>{{ recip.target_label }}</template>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </template>
                    </v-client-table>
                </div>
            </div>

            <div class="card" v-show="curTab == 'public'">
                <div class="card-body">
                    <div class="alert alert-info mb-2">
                        <strong>Public Access</strong> is a feature that allows non-users to access a Custom Forms landing page. From there, individual forms can be accessed and employee verification is deteremined based on the form.
                    </div>
                    <div class="row mt-2 mb-3">
                        <label class="col-md-3 text-md-right">Public Access URL:</label>
                        <div class="col-md-8">
                            <a :href="publicAccessUrl" target="_blank">{{ publicAccessUrl }}</a>
                        </div>
                    </div>
                    <div class="row mt-2 mb-3">
                        <label class="col-md-3 text-md-right">Public Access QR Code:</label>
                        <div class="col-md-8" v-if="sds_key">
                            <qr-code ref="customFormsQR"
                                    :qr_code_url="`${publicAccessUrl}`"
                                    :qr_code_name="'MeritEHS-Custom-Forms-Public-Access'"
                                    :qr_code_size="7" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
                curTab: 'entries',
                sds_key: null,
                forms: [],
                columns: ['id', 'covid_form_name', 'require_jobsite', 'require_employee_sig', 'enable_public_access', 'enable_guest_access'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        covid_form_name: 'Form Name',
                        require_jobsite: 'Require Jobsite',
                        require_employee_sig: 'Require Employee Signature',
                        enable_public_access: 'Enable Public Access',
                        enable_guest_access: 'Enable Guest Access',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'inc_alerts.id',
                    },
                },

                alertRules: [],
                alertColumns: ['id', 'alert_name', 'is_active'],
                alertOptions: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        alert_name: 'Name',
                        is_active: 'Status',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'inc_alerts.id',
                    },
                },
            }
        },

        computed: {

            publicAccessUrl(){
                //Build the URL
                return this.$root.appUrl + '/custom-forms/access/' + this.sds_key;
            },

            canManage(){
                //Send it
                return this.$root.hasPermission('custom_forms.manage');
            }
        },

        methods: {
            //Load up
            loadForms(){
                //Send it
                this.$http
                    .get('/custom-forms/forms/list')
                    .then(response => {
                        //Set all the data
                        this.forms = response.data.forms;
                        this.alertRules = response.data.email_alerts;
                        this.sds_key = response.data.sds_key;
                    })
                    .catch(response => {
                        //Set
                    })
                    .then(() => {

                    });
            },
        },

        mounted(){
            //Send it
            if(this.canManage)
            {
                this.loadForms();
            }

            if (this.$route.hash !== '' && this.$route.hash !== '#')
            {
                this.curTab = this.$route.hash.replace('#','')
            }
        },
    }
</script>
